import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {FloatingBubblesContainerBox} from './boxes/floating-bubbles-container.box';
import {FloatingBubbleBox} from './boxes/floating-bubble.box';
import {observer} from 'mobx-react';

export const FloatingBubblesComponent = observer(class FloatingBubblesComponent extends OrbitComponent {
    render() {
        const bubbles = this.services.floatingBubbles.bubbles;
        if(bubbles.length === 0) {
            return null;
        }

        return (<FloatingBubblesContainerBox className='cy-floating-bubbles'>
            {bubbles.map(bubble => <FloatingBubbleBox key={bubble.id} id={bubble.id} isVisible={bubble.isVisible} />)}
        </FloatingBubblesContainerBox>)
    }
});